import { GenericCrudPage } from '@/components/GenericCrudPage';
import { productsConfig } from '@/pages/configs';

export default function ProductsPage() {
  return <GenericCrudPage config={productsConfig} />;
}
